import { render, staticRenderFns } from "./StockDocumentPageHeading.vue?vue&type=template&id=712fc5f6&scoped=true"
import script from "./StockDocumentPageHeading.vue?vue&type=script&lang=js"
export * from "./StockDocumentPageHeading.vue?vue&type=script&lang=js"
import style0 from "./StockDocumentPageHeading.vue?vue&type=style&index=0&id=712fc5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712fc5f6",
  null
  
)

export default component.exports